import * as DeviceInfo from './deviceInfo/model';
import * as ReadRights from './readRights/model';
import * as Transfers from './transfer/model';
import * as Download from './download/model';
import * as DownloadLogs from './downloadLogs/model';
import * as Register from './register/model';

export enum Panels {
  DEVICE_DETAILS = 'DeviceInfo',
  DEVICE_LOGS = 'DeviceLogs',
  DEVICE_REGISTER = 'DeviceRegister',
  DEVICE_DOWNLOAD = 'DeviceDownload',
  DEVICE_DOWNLOAD_LOGS = 'DeviceDownloadLogs',
  DEVICE_READRIGHTS = 'DeviceReadRights',
  DEVICE_TRANSFER='TransferDevices',
  HELLO_WORLD= 'HELLO_WORLD',
  TRANSFER_DEVICES='TRANSFER_DEVICES'
}

export enum Modals {
  DEVICE_READRIGHTS_ASSIGN = 'DeviceReadRightsAssign',
  DEVICE_READRIGHTS_REMOVE = 'DeviceReadRightsRemove',
  DEVICE_ACTIVATE = 'DeviceActivate',
  DEVICE_REMOVE = 'DeviceRemove',
  DEVICE_SEARCHFILE = 'DeviceSearchViaFile',
  TABLE_SETTINGS = 'TableSettings',
  HELLO_WORLD= 'HelloWorld',
  TRANSFER_DEVICES='TRANSFER_DEVICES'
}

export type PanelsType = typeof Panels | '';

export type ModalsType = typeof Modals | '';

export type EnumOrEmpty<T> =  T | '';

export interface DialogState {
  activeDialog: PanelsType;
  activeModal: ModalsType;
  deviceInfoDialog: DeviceInfo.State;
  transferState: Transfers.State;
  readrightState: ReadRights.State;
  downloadState: Download.State;
  downloadLogsState: DownloadLogs.State;
  registerState: Register.State;
}
